/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/** @jsx jsx */
import React, {
  useState, useCallback, useMemo, useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { Column } from 'react-table';
import { Link } from 'react-router-dom';
import { SubActionButton } from 'components/atoms/Button';
import ToastModal from 'components/organismos/ToastModal';
import DataTable from 'components/organismos/DataTable/DataTable';
import TimeOutputLayoutDomain from 'domain/master/attend/timeOutputLayout';
import ConfirmModal from 'components/organismos/ConfirmModal';
import { getOutputLayoutList, deleteTimeOutputLayoutById } from 'api/timeOutputLayout';
import useToastNotification from 'hooks/useToastNotification';
import FormContents from 'components/atoms/Form/FormContents';
import IconLabelButton from 'components/molecules/IconLabelButton';
import BlockUI from 'components/molecules/BlockUi';
import FormPadding from "components/atoms/Form/FormPadding";
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FormHeader from 'components/templates/FormHeader';
import FlexBox from 'components/atoms/FlexBox';

const TimeOutputLayoutList = () => {
  const [timeOutputLayoutList, setTimeOutputLayoutList] = useState<Array<TimeOutputLayoutDomain>>([]);

  /**
   * useEffect
   */
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [toastMessage] = useState('');
  const [toastModalOpen, setToastModalOpen] = useState(false);
  const [selectedTimeOutputLayout, setSelectedTimeOutputLayout] = useState(
    TimeOutputLayoutDomain.generateInitial(),
  );
  const {  successNotification,errorNotification } = useToastNotification();
  const [isLoading, setIsLoading] = useState(false);
  
  /**
   * useEffect
   */
  useEffect(() => {
    setIsLoading(true);
    getOutputLayoutList().then((response: Array<any>) => {
      setIsLoading(false);
      setTimeOutputLayoutList(response.map((result) => new TimeOutputLayoutDomain(result)));
    });
  }, []);

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  const openConfirmModal = useCallback((timeOutputLayout: TimeOutputLayoutDomain) => {
    setConfirmModalOpen(true);
    setSelectedTimeOutputLayout(timeOutputLayout);
  }, []);

  /**
   * deleteTimeOutputLayoutMaster
   *
   * @param layoutId
   */
  const deleteTimeOutputLayoutMaster = useCallback(
    () => {
      deleteTimeOutputLayoutById(selectedTimeOutputLayout.layoutId).then((response: any) => {
        setTimeOutputLayoutList(
          timeOutputLayoutList.filter(
            (timeOutputLayout) => timeOutputLayout.layoutId !== selectedTimeOutputLayout.layoutId,
          ),
        );
        setConfirmModalOpen(false);
        successNotification('削除しました。'); //success 
      }).catch((error) => {
        setConfirmModalOpen(false);
        if (error.response && error.response.data && error.response.data.errors) {
          const listErr = error.response.data.errors;
          let stringErr = '';
          listErr.forEach((element: any) => {
            stringErr += `${element.defaultMessage}<br />`;
          });
          errorNotification(stringErr);
        } else {
          errorNotification('サーバー側でエラーが発生しました。');
          throw error;
        }
      });
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedTimeOutputLayout.layoutId, timeOutputLayoutList],
  );

  const columns: Array<Column<TimeOutputLayoutDomain>> = useMemo(() => [
    {
      Header: () => null,
      id: 'actionButton',
      disableSortBy: true,
      Cell: (cell: {
        row: { isExpanded: boolean, original: TimeOutputLayoutDomain },
        data: Array<TimeOutputLayoutDomain>
      }) => {
        return (
         <FlexBox>
          <FlexBoxItem marginLeft="5px"  width="36px">
            <Link to={`/masterTimeOutputLayout/edit/${cell.row.original.layoutId}`}>
                <SubActionButton action={0} text="編集" onClick={() => console.log(1)} />
              </Link>
           </FlexBoxItem>
            <FlexBoxItem margin="0 5px" width="36px">
              <SubActionButton action={1} text="削除" onClick={() => { openConfirmModal(cell.row.original)}}/>
            </FlexBoxItem>
         </FlexBox> 
          
        );
      },
    },
    {
      Header: 'レイアウトコード',
      accessor: 'layoutCode',
    },
    {
      Header: 'レイアウト名',
      accessor: 'layoutName',
    }
  ], [openConfirmModal]);

  const customStyle = {
    marginTop:'60px',
    marginBottom: '30px',
    borderRadius: '10px',
    // padding: "0 30px",
  }

  return (
    <BlockUI blocking={isLoading}>
    <React.Fragment>
      <div
        css={
          css`
          table tr th:nth-child(1){
            width: 84px;
          } 
          .button-action button:hover{
            background-color:transparent;
          }
        `
        }
      >
      <FormHeader title="勤怠確定出力レイアウト" />
        <FormContents customStyle={customStyle}>
          <FormPadding>
            <Link className="button-action" to="/masterTimeOutputLayout/add" style={{ textDecoration: 'none', color: '#007BC3', display: 'inline-block' }}>
              <IconLabelButton onClick={() => console.log('edit')} iconType="addCircle" text="追加" />
            </Link>
          </FormPadding>
            <div 
              className="table-bordered table-padding" 
              style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '15px' }}
            >
              <DataTable
                classNameParrant="border-left-right"
                className="table-no-border-left-right"
                columns={columns}
                data={timeOutputLayoutList}
                isGlobalFilter={true}
                minWidth="100%"
              />
            </div>
          <ConfirmModal
            open={confirmModalOpen}
            closeHandler={closeConfirmModal}
            onSubmit={deleteTimeOutputLayoutMaster}
            title="出力レイアウトの削除"
            content="勤務確定出力レイアウトを削除します。よろしいですか？"
            submitText="削除する"
            items={[]}
            typeSubmit={`reject`}
          />
          <ToastModal
            open={toastModalOpen}
            closeHandler={() => setToastModalOpen(false)}
            title={toastMessage}
          />
        </FormContents>
      </div>
    </React.Fragment>
    </BlockUI>
  );
};

export default TimeOutputLayoutList;
